import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

function AddBarModal({ open, onClose, onAdd }) {
  const [newBar, setNewBar] = useState({
    name: '',
    address: '',
    par: 3,
    drink: 'Beer',
  });
  const [saving, setSaving] = useState(false);

  const handleFieldChange = (field, value) => {
    setNewBar({ ...newBar, [field]: value });
  };

  const handleSave = async () => {
    // Validate required fields
    if (!newBar.name.trim()) {
      alert('Bar name is required');
      return;
    }
    if (!newBar.address.trim()) {
      alert('Bar address is required');
      return;
    }
    if (!newBar.par || newBar.par < 1) {
      alert('Par must be at least 1');
      return;
    }

    setSaving(true);
    try {
      const response = await axios.post(`${API_URL}/api/bars`, {
        name: newBar.name.trim(),
        address: newBar.address.trim(),
        par: parseInt(newBar.par),
        drink: newBar.drink.trim() || 'Beer',
      });

      if (onAdd) {
        onAdd(response.data);
      }
      
      // Reset form
      setNewBar({
        name: '',
        address: '',
        par: 3,
        drink: 'Beer',
      });
      
      onClose();
    } catch (error) {
      console.error('Error creating bar:', error);
      alert('Failed to create bar. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    // Reset form on close
    setNewBar({
      name: '',
      address: '',
      par: 3,
      drink: 'Beer',
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Bar</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
              Bar Information
            </Typography>
            <TextField
              fullWidth
              label="Bar Name"
              value={newBar.name}
              onChange={(e) => handleFieldChange('name', e.target.value)}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              fullWidth
              label="Address"
              value={newBar.address}
              onChange={(e) => handleFieldChange('address', e.target.value)}
              margin="normal"
              variant="outlined"
              required
            />
            <Box display="flex" gap={2} mt={2}>
              <TextField
                label="Par"
                type="number"
                value={newBar.par}
                onChange={(e) => handleFieldChange('par', e.target.value)}
                variant="outlined"
                sx={{ width: '150px' }}
                inputProps={{ min: 1 }}
                required
              />
              <TextField
                fullWidth
                label="Drink"
                value={newBar.drink}
                onChange={(e) => handleFieldChange('drink', e.target.value)}
                variant="outlined"
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          startIcon={<SaveIcon />}
          disabled={saving}
        >
          {saving ? 'Creating...' : 'Create Bar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddBarModal;



